import BaseService from '@/services/services/tools/baseService';
import AuthorsAPI from '@/services/api/internal/authors.api';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

const AuthorsService = new BaseService({
  api: AuthorsAPI,
});

AuthorsService.findAuthorsByOriginalIdx = (originalIdx) => {
  const originalIdxFilter = originalIdx.map((originalId) => {
    return {
      author_original_id: { $eq: originalId },
    };
  });
  const q = {
    $or: originalIdxFilter,
  };
  return AuthorsAPI.getItems({
    params: { q },
  })
    .then((response) => {
      const item = response.data.items;
      if (item) return item;
      throw new Error(`Users ${originalIdx} not in mv_users_ext`);
    })
    .catch(errorHandler);
};

export default AuthorsService;
